import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { PRODUCT_TITLE_METRIC_ENUM } from '../constants/metrics/seo-audit-metric';
import { ISeoDailyStatus, ISeoDailyStatusParams } from '../interfaces/IReportSeo';

class SeoAuditReportService extends EntityApiService<any> {
  seoStatusSummary = (params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/product/${PRODUCT_TITLE_METRIC_ENUM.SEO_STATUS_SUMMARY}`), params, config),
    );
  };

  seoKpis = (params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/product/${PRODUCT_TITLE_METRIC_ENUM.SEO_KPIS}`), params, config),
    );
  };

  seoIssuesRanking = (params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/product/${PRODUCT_TITLE_METRIC_ENUM.SEO_ISSUES_RANKING}`), params, config),
    );
  };

  seoScoreDistribution = (params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(
        this.getPath(`/product/${PRODUCT_TITLE_METRIC_ENUM.SEO_SCORE_DISTRIBUTION}`),
        params,
        config,
      ),
    );
  };

  seoActiveGates = (params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/product/${PRODUCT_TITLE_METRIC_ENUM.SEO_ACTIVE_GATES}`), params, config),
    );
  };

  searchProductSummary = (params?: any, config?: RequestConfig): any => {
    return this.handleSearchResponse(ApiClientService.post(this.getPath('/products-summary'), params, config), 5);
  };

  /** Evolucion diaria de productos por estado SEO (histograma). */
  dailyStatus = (params?: ISeoDailyStatusParams, config?: RequestConfig): Promise<ISeoDailyStatus> => {
    return this.handleResponse(ApiClientService.get(this.getPath('/daily-status'), { ...config, params }));
  };

  searchHistoricalSummary = (params?: any, config?: RequestConfig): any => {
    return this.handleSearchResponse(ApiClientService.post(this.getPath('/historical-summary'), params, config), 5);
  };
}

// Con `REACT_APP_SEO_AUDIT_URL` (p. ej. http://localhost:8088) este reporte habla directo con
// ese ms-analytics; vacio, sigue yendo por el gateway global.
const SEO_AUDIT_BASE_URL = process.env.REACT_APP_SEO_AUDIT_URL || '';

export default new SeoAuditReportService(`${SEO_AUDIT_BASE_URL}/ms-analytics/api/v1/content/seo`);
